import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PriorityManager, Priority } from '@app/shared/components/que-mnger-expand-config/priority';

@Component({
  selector: 'app-priority-dialog',
  templateUrl: './priority-dialog.component.html',
  styleUrls: ['./priority-dialog.component.scss']
})
export class PriorityDialogComponent {

  /****************** Variable declaration ******************/
  prioMgr = PriorityManager;
  selection: Priority;

  /**
   * Constructor
   * @param data
   * @param dialogRef
   */
  constructor(@Inject(MAT_DIALOG_DATA) public data: Priority,
    private dialogRef: MatDialogRef<PriorityDialogComponent>) {
    this.selection = data;
  }

  /**
   * hostlistener is being used here for DOM event to listen for change priority function
   */
  @HostListener('window:keydown.ArrowLeft', ['$event.key'])
  @HostListener('window:keydown.ArrowRight', ['$event.key'])
  changePriority(key: string) {
    if (key == 'ArrowRight') {
      this.selection = (this.selection + 1) % PriorityManager.len;
    } else if (key == 'ArrowLeft') {
      this.selection = (this.selection + (PriorityManager.len - 1)) % PriorityManager.len;
    }
  }
  
  /**
   *  hostlistener is being used here for DOM event to listen for change priority function
   */
  @HostListener('window:keyup.Enter')
  onSuccess() {
    if (this.data != this.selection) {
      this.dialogRef.close(Priority[this.selection])
    } else {
      this.dialogRef.close(null)
    }
  }
}
